module.exports = __webpack_public_path__ + "static/media/icon_tour_price.b61bdc6f.svg";